import React, { useEffect, useState } from "react";
import { Box, Grid, IconButton, Typography, Tooltip } from "@mui/material";
import CustomTable from "../../components/library/CustomTable/Index";
import DeleteIcon from "@mui/icons-material/Delete";
import CustomSearchBar from "../../components/library/CustomSearchBar";
import CustomModel from "../../components/library/CustomModel";
import EditIcon from "@mui/icons-material/Edit";
import CustomSelect from "../../components/library/CustomSelect";
import CutomConfirmationModel from "../../components/library/CutomConfirmationModel";
import { getUsers, deleteUser, addUser } from "./api";
import { getUserDetails } from "../../utils/utils";
import { toast } from "react-toastify";
import Loader from "../../components/loader";
import LocationPopup from "./ClientDetails/LocationPopup";

export default function UserDetails() {
  const [rows, setRows] = useState();
  const [allUserApiData, allUetuserApiData] = useState();
  const [filteredRows, setFilteredRows] = useState("");
  const [selectedRowData, setSelectedRowData] = useState("");
  const [isEditModel, setisEditModel] = useState(false);
  const [onSuccessModelClose, setonSuccessModelClose] = useState(false);
  const [customSelectValue, setcustomSelectValue] = useState("Employee");
  const [openConfirmationModel, setOpenConfirmationModel] = useState(false);
  const columns = ["First Name", "Last Name", "Email", "Password", "Actions"];
  const [loading, setloading] = useState(false);
  const [isDelete, setisDelete] = useState(false);
  const [isSearch, setIsSearch] = useState(0);
  const [searchVal, setSearchVal] = useState("");
  const [pagination, setpagination] = useState(0);

  const users = async () => {
    setSearchVal("");
    setpagination(0);
    let { email } = getUserDetails();
    let params = {
      role: customSelectValue,
      email: email,
    };
    let response = await getUsers(setloading, params);
    allUetuserApiData(response?.data);
    let data = response?.data?.map((item) => {
      let star = "";
      for (let i = 0; i < item?.password?.length; i++) {
        star += "*";
      }
      return {
        name: item?.firstName,
        lastname: item?.lastName,
        email: item?.email,
        password: star,
        actions: (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Tooltip title="Edit" arrow>
              <IconButton onClick={() => setisEditModel(true)}>
                <EditIcon color="secondary" />
              </IconButton>
            </Tooltip>

            {customSelectValue === "Client" && (
              <LocationPopup
                userId={item?.userId}
                userName={`${item?.firstName} ${item?.lastName}`}
              />
            )}

            <Tooltip title="Delete" arrow>
              <IconButton onClick={() => setOpenConfirmationModel(true)}>
                <DeleteIcon color="error" />
              </IconButton>
            </Tooltip>
          </Box>
        ),
        id: item?.userId,
      };
    });
    setRows(data);
    setFilteredRows(data);
  };

  useEffect(() => {
    users();
  }, [customSelectValue]);

  // this function is using for get selected user password and update them
  // when we click on edit icon this function will get filted email of selected user and take password of selected user
  function getUserPassword(email) {
    let password = "";
    allUserApiData?.forEach((data) => {
      if (data.email === email) {
        password = data.password;
      }
    });
    return password;
  }

  // An array where we have decleared all fields of Formik form
  const allFields = [
    {
      fieldName: "name",
      fieldLabel: "First Name",
      fieldType: "text",
      initialValue: selectedRowData?.name || "",
    },
    {
      fieldName: "lastname",
      fieldLabel: "Last Name",
      fieldType: "text",
      initialValue: selectedRowData?.lastname || "",
    },
    {
      fieldName: "email",
      fieldLabel: "Email",
      fieldType: "email",
      initialValue: selectedRowData?.email || "",
    },
    {
      fieldName: "password",
      fieldLabel: "Password",
      fieldType: "password",
      initialValue: getUserPassword(selectedRowData?.email),
    },
  ];

  // Add new User Api Calling
  async function addNewUser(addUserData) {
    let data = {
      firstName: addUserData?.name,
      lastName: addUserData?.lastname,
      email: addUserData?.email,
      password: addUserData?.password,
      role: customSelectValue,
    };

    if (selectedRowData && isEditModel) {
      data.userId = selectedRowData.id;
    } else {
      data.role = customSelectValue;
    }

    let response = await addUser(setloading, data);
    if (response) {
      setonSuccessModelClose(!onSuccessModelClose);
    }
    toast.success(response?.message);
    await users();
  }

  // delete confirmation
  useEffect(() => {
    if (isDelete) {
      setOpenConfirmationModel(false);
      setisDelete(false);
      if (selectedRowData?.id) {
        try {
          deleteData();
        } catch (error) {
          toast.error("Something went wrong!");
        }
      }
    }
  }, [isDelete]);

  // Function For delete selected user data
  const deleteData = async () => {
    let response = await deleteUser(setloading, selectedRowData?.id);
    toast.success(response.message || "User deleted successfully!");
    await users();
  };

  return (
    <div>
      {loading && <Loader />}

      <CutomConfirmationModel
        open={openConfirmationModel}
        setOpen={setOpenConfirmationModel}
        title={"Delete Confirmation"}
        messege={
          <Typography>
            Are you sure you want to delete the account belonging to
            <span style={{ color: "red" }}>
              {" "}
              {selectedRowData?.name} {selectedRowData?.lastname}{" "}
            </span>
            ?
          </Typography>
        }
        setisAction={setisDelete}
      />

      <Grid container gap={2} justifyContent={"space-between"}>
        <Grid item md={3} lg={2} xl={1.5} xs={12} sm={12}>
          <CustomModel
            title={`${isEditModel ? "Edit" : "Add new"} ${customSelectValue}`}
            buttonTitle={`${
              isEditModel ? "Edit" : "Add new"
            }  ${customSelectValue}`}
            allFields={allFields}
            isEditModel={isEditModel}
            setisEditModel={setisEditModel}
            formMethod={addNewUser}
            onSuccessModelClose={onSuccessModelClose}
            setSelectedRowData={setSelectedRowData}
          />
        </Grid>

        <Grid item md={3} lg={2} xs={12} sm={12}>
          <CustomSelect
            setpagination={setpagination}
            filterValue={customSelectValue}
            setFilterValue={setcustomSelectValue}
            title={"Filter by"}
            options={[
              { key: "Employee", value: "Employee" },
              { key: "Admin", value: "Admin" },
              { key: "Client", value: "Client" },
            ]}
          />
        </Grid>

        <Grid item md={3} lg={2} xs={12} sm={12}>
          <CustomSearchBar
            rows={rows}
            setFilteredRows={setFilteredRows}
            setpagination={setpagination}
            setIsSearch={setIsSearch}
            searchVal={searchVal}
            setSearchVal={setSearchVal}
          />
        </Grid>
      </Grid>

      <Box sx={{ mt: 3 }}>
        <CustomTable
          pagination={pagination}
          setSelectedRowData={setSelectedRowData}
          rows={filteredRows}
          columns={columns}
          isSearch={isSearch}
        />
      </Box>
    </div>
  );
}
